// Observer Registry
const authExpObservers = new Set();
const errorObservers = new Set();
const errorResponseObservers = new Set();

// Function to add Auth Expired observer
const addAuthExpObservers = (observer) => {
  if (!authExpObservers.has(observer)) authExpObservers.add(observer);
};
const removeAuthExpObservers = (observer) => {
  authExpObservers.delete(observer);
};
const removeAllAuthExpObservers = () => {
  authExpObservers.clear();
};
const notifyAuthExpObservers = (...responseData) => {
  authExpObservers.forEach((observer) => {
    observer(...responseData);
  });
};

// Function to  error observer
const addErrorObservers = (observer) => {
  if (!errorObservers.has(observer)) errorObservers.add(observer);
};
const removeErrorObservers = (observer) => {
  errorObservers.delete(observer);
};
const removeAllErrorObservers = () => {
  errorObservers.clear();
};
const notifyErrorObservers = (...responseData) => {
  errorObservers.forEach((observer) => {
    observer(...responseData);
  });
};

const addErrorResponseObservers = (observer) => {
  if (!errorResponseObservers.has(observer)) errorResponseObservers.add(observer);
};
const removeErrorResponseObservers = (observer) => {
  errorResponseObservers.delete(observer);
};
const removeAllErrorResponseObservers = () => {
  errorResponseObservers.clear();
};
const notifyErrorResponseObservers = (...responseData) => {
  errorResponseObservers.forEach((observer) => {
    observer(...responseData);
  });
};

const apiObserver = {
  add: {
    authExpHandler: addAuthExpObservers,
    errorHandler: addErrorObservers,
    errorResponseHandler: addErrorResponseObservers,
  },
  remove: {
    authExpHandler: removeAuthExpObservers,
    errorHandler: removeErrorObservers,
    errorResponseHandler: removeErrorResponseObservers,
  },
  removeAll: {
    authExpHandler: removeAllAuthExpObservers,
    errorHandler: removeAllErrorObservers,
    errorResponseHandler: removeAllErrorResponseObservers,
  },
  notify: {
    authExpHandler: notifyAuthExpObservers,
    errorHandler: notifyErrorObservers,
    errorResponseHandler: notifyErrorResponseObservers,
  },
};

export default apiObserver;
